import { formatMoney } from '@/lib/format';
import { cn } from '@/lib/utils';

export interface MoneyProps {
  value: number | string;
  currency?: string;
  locale?: string;
  className?: string;
}

export function Money({
  value,
  currency = 'PEN',
  locale = 'es-PE',
  className,
}: MoneyProps): JSX.Element {
  return (
    <span className={cn('tabular-nums', className)}>
      {formatMoney(value, currency, locale)}
    </span>
  );
}
